const Content = {
    'network': {
        'number': '',
        'title': 'NRG is a proud member of the Stagwell Group',
        'body': 'Led by a group of agency and industry professionals, Stagwell is building an investment portfolio of marketing services companies that puts digital first without being weighed down by legacy assets. The Stagwell Group has only one of each kind of agency from digital media buying to market research to public relations and beyond to allow for true cooperation. Most importantly, Stagwell knows great talent needs to be valued and nurtured to achieve best in class growth. To facilitate that growth, Stagwell acts as a value added investor, not simply a manager, through new business development, strategic counsel and add-on acquisitions that keep agencies like NRG on the cutting edge of marketing innovation. NRG was Stagwell’s second acquisition; as a full-service market research consultancy, we fit the Stagwell thesis perfectly and are excited to work with the other members of the Stagwell family.'
    },
    'extension': {
        logos: [
          {
              'className': 'ct',
              'viewBox': '0 0 185.8 13.7',
              'iconName': 'logo-candt',
              'href': 'http://www.codeandtheory.com/'
          },
          {
              'className': 'skd',
              'viewBox': '0 0 185.8 26.6',
              'iconName': 'logo-skd',
              'href': 'http://www.skdknick.com/'
          },
          {
              'className': 'nrg',
              'viewBox': '0 0 307.1 113.6',
              'iconName': 'nrg-stagwell',
              'href': 'http://nationalresearchgroup.com/'
          },
          {
              'className': 'pmx',
              'viewBox': '0 0 86.3 43.6',
              'iconName': 'logo-pmx',
              'href': 'http://www.pmxagency.com/'
          },
          {
              'className': 'wye',
              'viewBox': '0 0 181.3 18.3',
              'iconName': 'logo-wye',
              'href': 'http://www.stagwellgroup.com/'
          },
          {
              'className': 'finn',
              'viewBox':  '0 0 3400.1 540',
              'iconName': 'logo-finn',
              'href': 'https://www.finnpartners.com/'
          },
          {
              'className': 'harris',
              'viewBox': '-150 0 2236 384',
              'iconName': 'logo-harris',
              'href': 'http://harrisinsights.com/'
          },
          {
              'className': 'harrisx',
              'viewBox':  '0 0 4000.5 420.6',
              'iconName': 'logo-harrisx',
              'href': 'http://harrisinsights.com/'
          },
          {
              'className': 'mmi',
              'viewBox':  '0 0 3500 414.66666',
              'iconName': 'logo-mmi',
              'href': 'https://www.mmiagency.com/'
          },
          {
              'className': 'scout',
              'viewBox': '0 0 3220 658.75604',
              'iconName': 'logo-scout',
              'href': 'https://findscout.com/'
          },
          {
              'className': 'stagtech',
              'viewBox':  '0 0 2132 98.666664',
              'iconName': 'logo-stagtech',
              'href': 'http://www.stagwellgroup.com/'
          },
          {
              'className': 'targ',
              'viewBox':  '0 0 25000 2742.6667',
              'iconName': 'logo-targ',
              'href': 'https://www.targetedvictory.com/'
          },
          {
              'className': 'wolf',
              'viewBox':  '0 0 4000 388',
              'iconName': 'logo-wolf',
              'href': 'http://wolfgangla.com/'
          },
        {
            'className': 'forward',
            'viewBox':  '0 -75 1000 450',
            'iconName': 'logo-forward',
            'href': 'http://www.forward3d.com/'
        }
        ],
        'anchor': {
            'text': 'Visit the Stagwell Group',
            'href': 'http://www.stagwellgroup.com/'
        }
    }
};

export { Content };
